// extracted by mini-css-extract-plugin
export var animationContainer = "_i3-0";
export var asteriskIcon = "_i3-8";
export var conversationLeftSection = "_i3-4";
export var conversationListItem = "_i3-3";
export var conversationMiddleSection = "_i3-5";
export var conversationRightSection = "_i3-6";
export var detailsContent = "_i3-1";
export var listContainer = "_i3-7";
export var modalContent = "_i3-2";